/*
 * ATTENTION: An "eval-source-map" devtool has been used.
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file with attached SourceMaps in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./zrc/scripts/sections/homepage/tabs-with-collections.js":
/*!****************************************************************!*\
  !*** ./zrc/scripts/sections/homepage/tabs-with-collections.js ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! swiper */ \"./node_modules/swiper/swiper.esm.js\");\n/* harmony import */ var hequalizer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! hequalizer */ \"./node_modules/hequalizer/hequalizer.min.js\");\n/* harmony import */ var hequalizer__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(hequalizer__WEBPACK_IMPORTED_MODULE_1__);\n/* eslint-disable babel/object-curly-spacing */\n\n\nvar nameCustomElement = \"tabs-with-collections\";\nclass CustomCardsGrid extends window.HTMLElement {\n  connectedCallback() {\n    this.hequalizerItems = [\"art-number\", \"title\", \"price\"];\n    this.configSliderContents();\n    this.querySelector(\"tabs-component\").addEventListener(\"change\", () => {\n      window.dispatchEvent(new window.Event(\"resize\"));\n    });\n  }\n  configSliderContents() {\n    var $contents = this.querySelectorAll(\".tabs-with-collections-content\");\n    $contents.forEach($content => {\n      var $sliderContainer = $content.querySelector(\".tabs-with-collections-items\");\n      var $prevEl = this.querySelectorAll(\"[data-tab-arrows]\")[$content.dataset.index].querySelector(\".prev\");\n      var $nextEl = this.querySelectorAll(\"[data-tab-arrows]\")[$content.dataset.index].querySelector(\".next\");\n      new swiper__WEBPACK_IMPORTED_MODULE_0__.default($sliderContainer, {\n        modules: [swiper__WEBPACK_IMPORTED_MODULE_0__.Navigation],\n        loop: false,\n        slidesPerView: \"auto\",\n        centerInsufficientSlides: true,\n        threshold: 10,\n        navigation: {\n          prevEl: $prevEl,\n          nextEl: $nextEl\n        }\n      });\n      this.setHequalizer($sliderContainer);\n    });\n  }\n  setHequalizer($container) {\n    this.hequalizerItems.forEach(item => {\n      var $elements = $container.querySelectorAll(\"[data-hequalizer='\".concat(item, \"']\"));\n      new (hequalizer__WEBPACK_IMPORTED_MODULE_1___default())($elements, {});\n    });\n  }\n}\nif (!window.customElements.get(nameCustomElement)) {\n  window.customElements.define(nameCustomElement, CustomCardsGrid);\n}//# sourceURL=[module]\n//# sourceMappingURL=data:application/json;charset=utf-8;base64,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\n//# sourceURL=webpack-internal:///./zrc/scripts/sections/homepage/tabs-with-collections.js\n");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		if(__webpack_module_cache__[moduleId]) {
/******/ 			return __webpack_module_cache__[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/******/ 	// the startup function
/******/ 	// It's empty as some runtime module handles the default behavior
/******/ 	__webpack_require__.x = x => {};
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// Promise = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"tabs-with-collections": 0
/******/ 		};
/******/ 		
/******/ 		var deferredModules = [
/******/ 			["./zrc/scripts/sections/homepage/tabs-with-collections.js","custom-commons"]
/******/ 		];
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		var checkDeferredModules = x => {};
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime, executeModules] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0, resolves = [];
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					resolves.push(installedChunks[chunkId][0]);
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			for(moduleId in moreModules) {
/******/ 				if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 					__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 				}
/******/ 			}
/******/ 			if(runtime) runtime(__webpack_require__);
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			while(resolves.length) {
/******/ 				resolves.shift()();
/******/ 			}
/******/ 		
/******/ 			// add entry modules from loaded chunk to deferred list
/******/ 			if(executeModules) deferredModules.push.apply(deferredModules, executeModules);
/******/ 		
/******/ 			// run deferred modules when all chunks ready
/******/ 			return checkDeferredModules();
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkfantasias_miguel"] = self["webpackChunkfantasias_miguel"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 		
/******/ 		function checkDeferredModulesImpl() {
/******/ 			var result;
/******/ 			for(var i = 0; i < deferredModules.length; i++) {
/******/ 				var deferredModule = deferredModules[i];
/******/ 				var fulfilled = true;
/******/ 				for(var j = 1; j < deferredModule.length; j++) {
/******/ 					var depId = deferredModule[j];
/******/ 					if(installedChunks[depId] !== 0) fulfilled = false;
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferredModules.splice(i--, 1);
/******/ 					result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
/******/ 				}
/******/ 			}
/******/ 			if(deferredModules.length === 0) {
/******/ 				__webpack_require__.x();
/******/ 				__webpack_require__.x = x => {};
/******/ 			}
/******/ 			return result;
/******/ 		}
/******/ 		var startup = __webpack_require__.x;
/******/ 		__webpack_require__.x = () => {
/******/ 			// reset startup function so it can be called again when more startup code is added
/******/ 			__webpack_require__.x = startup || (x => {});
/******/ 			return (checkDeferredModules = checkDeferredModulesImpl)();
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	// run startup
/******/ 	__webpack_require__.x();
/******/ })()
;